import React from "react";

interface NavHeaderProps {
  onBack: () => void;
}

const NavHeader: React.FC<NavHeaderProps> = ({ onBack }) => (
  <div className="bg-black text-white">
    <div className="max-w-md mx-auto px-6 py-4 flex items-center relative">
      <button
        type="button"
        onClick={onBack}
        className="text-white hover:text-white/80 transition-colors"
        aria-label="Go back"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 12H5M12 19l-7-7 7-7"
          />
        </svg>
      </button>
      <div className="w-2" />
      <h2 className="text-lg font-light">Event Page</h2>
    </div>
  </div>
);

export default NavHeader;
